import type { RelistAdditionalFieldsToRenderProps } from '../model/RelistAdditionalFields';
import RelistAdditionalFieldsToRender from '../model/RelistAdditionalFields';

const ACTION = {
  UPDATE_ADDITIONAL_FIELDS_TO_RENDER: 'UPDATE_ADDITIONAL_FIELDS_TO_RENDER',
};

const RELIST_INIT_STATE = {
  renderAdditionalDetailsPage: null,
  fieldsToRender: RelistAdditionalFieldsToRender(),
};

const relist = (
  state = RELIST_INIT_STATE,
  action: {
    type?: string;
    payload?: { fieldsToRender: RelistAdditionalFieldsToRenderProps; renderAdditionalDetailsPage: boolean };
  } = {},
) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION.UPDATE_ADDITIONAL_FIELDS_TO_RENDER:
      if (!payload) return { ...state };

      return {
        ...state,
        fieldsToRender: {
          ...payload?.fieldsToRender,
        },
        renderAdditionalDetailsPage: payload?.renderAdditionalDetailsPage,
      };

    default:
      return state;
  }
};

export { ACTION, RELIST_INIT_STATE };
export default relist;
